import React, { useEffect, useState, useCallback } from 'react';
import Modal from 'react-modal';
import MyButton from '../../basic/MyButton';
import MyGraph from '../../basic/MyGraphFamily';
import { fetchRecentTransactions } from '../../../api';
import { useFamily } from '../../../context/FamilyContext';
import { currencies } from '../../basic/currencies';
import './modalTransactions.css';

Modal.setAppElement('#root');

function ModalTransactions({ userId, accountId, accountName, isOpen, onRequestClose }) {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const { currencyCode } = useFamily();

    const getCurrencySymbol = useCallback(() => {
        const currency = currencies.find(c => c.code === currencyCode);
        return currency ? currency.symbol : '$'; // Default to '$' if not found
    }, [currencyCode]);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isOpen) {
            setLoading(true);
            fetchRecentTransactions(userId, accountId)
                .then(data => {
                    const sortedTransactions = data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
                    setTransactions(sortedTransactions);
                    setLoading(false);
                })
                .catch(err => {
                    console.error('Error fetching transactions:', err);
                    setError('Failed to load transactions.');
                    setLoading(false);
                });
        }
    }, [userId, accountId, isOpen]);

    const graphData = transactions.map(tx => ({
        date: tx.timestamp,
        balance: tx.total_account_after,
        reason: tx.reason
    })).reverse();

    const modalTitle = `${accountName} Transactions (${transactions.length}) in the past 30 days`;

    const showGraph = windowWidth > 820;

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel={modalTitle}
            className="modal-transactions"
            overlayClassName="modal-transactions-overlay"
        >
            <h2 className="modal-transactions__title">{modalTitle}</h2>
            
            {loading ? (
                <p>Loading...</p>
            ) : error ? (
                <p className="modal-transactions__error">{error}</p>
            ) : (
                <>
                    {showGraph && (
                        <div className="modal-transactions__graph">
                            {transactions.length > 0 && <MyGraph data={graphData} width={820} height={300} />}
                        </div>
                    )}
                    <div className="modal-transactions__list">
                        {transactions.length ? (
                            <ul>
                                {transactions.map(tx => (
                                    <li key={tx.transaction_id} className="modal-transactions__item">
                                        <div className="modal-transactions__item-content">
                                            <div>
                                                <p className="modal-transactions__item-reason">{tx.reason}</p>
                                                <p className="modal-transactions__item-type">{tx.transaction_type}</p>
                                                <p className="modal-transactions__item-date">{new Date(tx.timestamp).toLocaleString()}</p>
                                            </div>
                                            <div className="modal-transactions__item-amount">
                                                <p className={`modal-transactions__item-change ${tx.transaction_type === 'deposit' ? 'positive' : 'negative'}`}>
                                                    {tx.transaction_type === 'deposit' ? '+' : '-'}{getCurrencySymbol()}{tx.amount}
                                                </p>
                                                <p className="modal-transactions__item-balance">Balance: {getCurrencySymbol()}{tx.total_account_after}</p>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No transactions found.</p>
                        )}
                    </div>
                </>
            )}
            
            <MyButton 
                text="Close" 
                onClick={onRequestClose} 
                backgroundColor="#f0f0f0"
                color="#333"
                hoverBackgroundColor="#e0e0e0"
                className="modal-transactions__close-button"
            />
        </Modal>
    );
}

export default ModalTransactions;